import { FaDownload } from "react-icons/fa";
import PortalLayout from "./PortalLayout";import { connect } from 'react-redux';
import SubLoading from "../Loading/SubLoading";

const StudentResults = ({ profile }) => {
    //console.log(profile)
    return ( 
        <PortalLayout>
            {
                profile ? (
                    <>
                        {
                            profile.resultsLink ? (
                                <div className="container row pt-5">
                                    <div className="col s12 m4 l4">
                                        <div className="card-panel grey lighten-5 z-depth-1 smooth-edge-2">
                                            <p className="grey-text text-darken-2 center is-size-5">{profile.forenames} {profile.surname}</p>
                                            <p className="grey-text text-lighten-1 has-text-weight-light my-3 center small-text">Released On: {profile.crDate}</p>
                                            <p className="grey-text text-darken-2 center mt-2 mb-3 is-size-6">{profile.currentResultsTerm}</p>
                                            <div className="center">
                                                <a 
                                                    className="button is-success mt-3 mb-1" 
                                                    href={profile.resultsLink}
                                                    download
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    <span className="icon">
                                                        <FaDownload color="white"/>
                                                    </span>
                                                    <span className="white-text">Download Results</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="container pt-6">
                                    <p className="center has-text-weight-semibold grey-text text-darken-2 is-size-4 mb-4">No results added yet !</p>
                                </div>
                            )
                        }
                    </>

                ) : (
                    <SubLoading />
                )
            }
        </PortalLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        profile: state.firebase.profile,
    }
    
}
export default connect(mapStateToProps)(StudentResults);